// Sample content for sections that need a provider TeleCalX doesn't have yet (campaigns need SMS / WhatsApp).

export function samplePages({ plan, upgradePlan }) {
  return {
    campaigns: {
      title: 'Campaigns',
      subtitle: `Create customer outreach campaigns. Campaign creation requires the ${upgradePlan} plan.`,
      stats: [['Campaigns', '0', `${plan} access`], ['Contacts eligible', '—', 'Upgrade required'], ['Messages sent', '—', 'Upgrade required'], ['Delivery rate', '—', 'Upgrade required']],
      actions: ['Compare plans', 'View campaign examples'],
      columns: ['Campaign', 'Channel', 'Audience', 'Schedule', 'Access'],
      rows: [
        ['WhatsApp follow-up', 'WhatsApp', 'Contact segments', 'Not scheduled', upgradePlan],
        ['Missed-call callback', 'Voice automation', 'Missed callers', 'Not scheduled', upgradePlan],
        ['Appointment reminders', 'SMS', 'Upcoming appointments', 'Not scheduled', upgradePlan],
      ],
    },
  };
}
